import { z } from "zod";

// Define the schema type first to handle recursion
type ProductCategorySchemaType = z.ZodObject<{
  name: z.ZodString;
  slug: z.ZodString;
  viewCount: z.ZodNumber;
  subCategories: z.ZodOptional<z.ZodArray<z.ZodLazy<z.ZodTypeAny>>>;
  id: z.ZodOptional<z.ZodString>;
  createdAt: z.ZodOptional<z.ZodString>;
  updatedAt: z.ZodOptional<z.ZodString>;
}>;

export const productCategoryInputSchema: ProductCategorySchemaType = z.object({
  // Required fields from CategoryItem
  name: z.string().min(3, "Name must be at least 3 characters"),
  slug: z.string().min(3, "Slug must be at least 3 characters"),
  viewCount: z.number().min(0),

  // Optional fields
  subCategories: z.array(z.lazy(() => productCategoryInputSchema)).optional(),

  // Standard fields handled by the server
  id: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
})

export type ProductCategoryInputItem = z.infer<typeof productCategoryInputSchema>
